import { ReactNode } from "react";
import { cva, VariantProps } from "class-variance-authority";

const styles = cva(["relative z-10"]);
type VProps = VariantProps<typeof styles>;

export interface MenuContainerProps extends VProps {
  className?: string;
  children: ReactNode;
}

/**
 *
 */
export const MenuContainer = ({ className, children }: MenuContainerProps) => {
  return <div className={styles({ className })}>{children}</div>;
};
